<div class="modal">
	<div class="modal-content">
		<div class="modal-header">
			<h2>Add Address</h2>
			<span class="close" (click)="activeModal.dismiss({ marker: null, address: null })">&times;</span>
		</div>
		<div class="modal-body">
			<form [formGroup]="customerInfoForm" >
				<div class="d-flex align-items-start gap-4 flex-none-column align-items-none-start">
					<div class="form-check form-check-inline d-flex">
						<input class="form-check-input" type="radio" formControlName="address_name" id="inlineRadio1" value="home" selected>
						<label class="form-check-label" for="inlineRadio1">Home</label>
					</div>
					<div class="form-check form-check-inline  d-flex">
						<input class="form-check-input" type="radio" formControlName="address_name" id="inlineRadio2" value="work">
						<label class="form-check-label" for="inlineRadio2">Work</label>
					</div>
					<div class="form-check form-check-inline  d-flex">
						<input class="form-check-input" type="radio" formControlName="address_name" id="inlineRadio3" value="others">
						<label class="form-check-label" for="inlineRadio3">Others</label>
					</div>
				</div>
				<div
					class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
					
					<div class="d-flex flex-column w-50 gap-3 w-none-100">
						<fieldset class=""
							[ngClass]="{ 'has-error': (isSubmitted || f.building_name.dirty) && f.building_name?.errors }">
							<label i18n="@@business.building_name">Building Name</label>
							<input type="text" name="building_name" formControlName="building_name"
								(keypress)="validateInput($event)" />
							<span class="field-error" i18n="@@error.required.building_name"
								*ngIf="(isSubmitted || f.building_name.touched) && f.building_name.errors?.required">Required</span>
							<span class="field-error" *ngIf="f.building_name.errors?.serverError">{{
								f.building_name.errors?.serverError }}</span>
						</fieldset>
					</div>
					<div class="d-flex flex-column w-50 gap-3 w-none-100">
						<fieldset class=""
							[ngClass]="{ 'has-error': (isSubmitted || f.street.dirty) && f.street?.errors }">
							<label i18n="@@business.street">Street</label>
							<input type="text" name="street" formControlName="street"
								(keypress)="validateInput($event)" />
							<span class="field-error" i18n="@@error.required.street"
								*ngIf="(isSubmitted || f.street.touched) && f.street.errors?.required">Required</span>
							<span class="field-error" *ngIf="f.street.errors?.serverError">{{
								f.street.errors?.serverError }}</span>
						</fieldset>
					</div>
					<div class="d-flex flex-column w-50 gap-3 w-none-100">
						<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.area.dirty) && f.area?.errors }">
							<label i18n="@@business.area">Area</label>
							<input type="text" name="area" formControlName="area" (keypress)="validateInput($event)" />
							<span class="field-error" i18n="@@error.required.area"
								*ngIf="(isSubmitted || f.area.touched) && f.area.errors?.required">Required</span>
							<span class="field-error" *ngIf="f.area.errors?.serverError">{{ f.area.errors?.serverError
								}}</span>
						</fieldset>
					</div>
					<div class="d-flex flex-column w-50 gap-3 w-none-100">
						<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.zipcode.dirty) && f.zipcode?.errors }">
							<label i18n="@@business.zipcode">Zipcode</label>
							<input type="text" name="zipcode" formControlName="zipcode" (keypress)="validateInput($event)" />
							<span class="field-error" i18n="@@error.required.zipcode"
								*ngIf="(isSubmitted || f.zipcode.touched) && f.zipcode.errors?.required">Required</span>
							<span class="field-error" *ngIf="f.zipcode.errors?.serverError">{{ f.area.errors?.serverError
								}}</span>
						</fieldset>
					</div>
				</div>

				<div
					class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
					<div class="d-flex flex-column w-50 gap-3 w-none-100">
						<fieldset class=""
							[ngClass]="{ 'has-error': (isSubmitted || f.country_id.dirty) && f.country_id?.errors }">
							<label i18n="@@store.country">Country</label>
							<select app-select2 [options]="{
								ajax: {url: countryListApi},
								idColumn: 'id',
								textColumn: 'name'
								}"
								[selected]="selectedCountry ? {id: selectedCountry?.id, text: selectedCountry?.name} : null"
								i18n-placeholder="@@business.country_placeholder" placeholder="Please type country name"
								name="country_id" formControlName="country_id" id="selectToCountry" (itemSelected)="onCountryChangeTrigger($event)">
								<option></option>
							</select>
							<span class="field-error" i18n="@@error.required"
								*ngIf="(isSubmitted || f.country_id.touched) && f.country_id.errors?.required">Required</span>
							<span class="field-error" *ngIf="f.country_id.errors?.serverError">{{
								f.country_id.errors?.serverError }}</span>
						</fieldset>
					</div>

					<ng-container *ngIf="outsideSA; else insideSA">
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.city.dirty) && f.city?.errors }">
								<label i18n="@@store.city">City</label>
								<input type="text" name="city" formControlName="city">
								<span class="field-error" i18n="@@error.required"
									*ngIf="(isSubmitted || f.city.dirty) && f.city.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.city.errors?.serverError">{{
									f.city.errors?.serverError }}</span>
							</fieldset>
						</div>
					</ng-container>
					<ng-template #insideSA>
						<!-- <div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.region_id.dirty) && f.region_id?.errors }">
								<label i18n="@@store.region">Region</label>
								<select app-select2 [options]="{
										ajax: {url: regionListApi},
										idColumn: 'id',
										textColumn: 'name'
									}" (itemSelected)="onChangeRegion($event)"
									[selected]="selectedRegion ? {id: selectedRegion.id, text: selectedRegion.name}  : {}"
									i18n-placeholder="@@store.please_select" data-placeholder="Select Region"
									formControlName="region_id" id="selectToRegion">
									<option></option>
								</select>
								<span class="field-error" i18n="@@error.required"
									*ngIf="(isSubmitted || f.region_id.touched) && f.region_id.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.region_id.errors?.serverError">{{
									f.region_id.errors?.serverError }}</span>
							</fieldset>
						</div> -->
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.city_id.dirty) && f.city_id?.errors }">
								<label i18n="@@store.city">City</label>
								<select app-select2 [options]="{
										ajax: {url: cityListApi},
										idColumn: 'id',
										textColumn: 'name'
									}" [params]="{cityId:f.region_id.value}" (itemSelected)="onChangeCity($event)"
									[selected]="selectedCity ? {id: selectedCity.id, text: selectedCity.name}  : {}"
									i18n-placeholder="@@store.please_select" placeholder="Select City"
									data-placeholder="Select City" formControlName="city_id" id="selectToCity">
									<option></option>
								</select>
								<span class="field-error" i18n="@@error.required"
									*ngIf="(isSubmitted || f.city_id.touched) && f.city_id.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.city_id.errors?.serverError">{{
									f.city_id.errors?.serverError }}</span>
							</fieldset>
						</div>
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.district_id.dirty) && f.district_id?.errors }">
								<label i18n="@@store.district">District</label>
								<select app-select2 [options]="{
										data: districts ? districts : [],
										idColumn: 'id',
										textColumn: 'name'
									}" [selected]="selectedDistrict ? {id: selectedDistrict.id, text: selectedDistrict.name}  : {}"
									i18n-placeholder="@@store.please_select" placeholder="Select District"
									data-placeholder="Select District" formControlName="district_id" id="selectToDistrict">
									<option></option>
								</select>
								<span class="field-error" i18n="@@error.required"
									*ngIf="(isSubmitted || f.district_id.touched) && f.district_id.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.district_id.errors?.serverError">{{
									f.district_id.errors?.serverError }}</span>
							</fieldset>
						</div>
					</ng-template>
				</div>

				<div class="form-group">
					<div class="form-check">
						<input class="form-check-input" type="checkbox" formControlName="is_default" id="isDefault">
						<label class="form-check-label" for="checkDefault">
						  Default Address
						</label>
					</div>
					<div class="form-group">
						<label>Enter address</label>
						<input type="text" class="form-control" placeholder="Search Nearest Location" type="text" #search>
					</div>

					<agm-map [latitude]="marker?.latitude" [longitude]="marker?.longitude" [zoom]="zoom">
						<agm-marker [latitude]="marker?.latitude" [longitude]="marker?.longitude" [markerDraggable]="true" (dragEnd)="markerDragEnd($event)"></agm-marker>
					</agm-map>

					<span *ngIf="marker && marker?.latitude && address">
						{{ marker | json }}
						{{ address }}
					</span>					
				</div>
				<div class="form-actions">
					<button type="button" class="btn btn-primary" (click)="submit()">Save</button>
				</div>
			</form>
		</div>
	</div>
</div>